import script from "./TicketDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketDetail.vue?vue&type=script&setup=true&lang=js"

import "./TicketDetail.vue?vue&type=style&index=0&id=0c301d14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c301d14"]])

export default __exports__